import { selectSite, clearActiveSite } from '../services/authService';

/**
 * The site a customer opens on: the first one the API listed, the same way the first firm is the one
 * activated at login. The frontend deliberately does not look at `isMain` — the order is the backend's
 * to decide. `null` when the customer has no sites.
 *
 * @param {Array<{haloPsaSiteId:number,siteName:string}>|undefined} sites
 */
export function getDefaultSite(sites) {
  return Array.isArray(sites) ? (sites[0] ?? null) : null;
}

/**
 * Points the backend's active-site cookie at a site of `company`: the explicit `site` when given,
 * otherwise the customer's first site, or clears the cookie when the customer has none.
 *
 * The cookie otherwise keeps belonging to whatever customer was active before, and the backend only
 * checks that the user is a member of the site, not that it belongs to the active firm — a stale site
 * would scope the new customer's data to the old customer's site. Call AFTER `selectCompany`: the
 * backend also verifies the site against the active firm.
 *
 * @param {{sites?: Array}} company
 * @param {{haloPsaSiteId:number}} [site]
 */
export async function activateDefaultSite(company, site) {
  const target = site ?? getDefaultSite(company?.sites);
  if (target) {
    await selectSite(target.haloPsaSiteId);
  } else {
    await clearActiveSite();
  }
}
